module.exports = __webpack_public_path__ + "static/media/google-play-qr.fb3783a4.svg";